import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { Survey, SurveyQuestion } from 'types/survey';
import { Answer } from 'types/surveyResponse';
import { AUDIO_CATEGORY } from 'types/attachmentTypes';
import { TextInput } from 'components/ui/TextInput';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';
import { getAttachmentsOfType, updateAttachmentsOfType } from 'utils/survey';

interface IProps {
  surveyDefinition: Survey;
  question: SurveyQuestion;
  answer: Answer;
  onChange: (answer: Answer) => void;
}

export const TextQuestion = ({ surveyDefinition, question, answer, onChange }: IProps) => {
  const [value, setValue] = useState(answer.value?.toString() ?? '');
  const ts = useSurveyTranslation(surveyDefinition);
  const onChangeDebounced = useDebouncedCallback(value => onChange({ ...answer, value }), 1500, { maxWait: 10000 });

  // make sure to do one last update on component unmount
  useEffect(() => {
    return () => {
      onChangeDebounced.flush();
    }
  }, []);
  
  const onInput = (value: string) => {
    if (question.maxLength && value.length > question.maxLength) {
      return;
    }
    setValue(value);
    onChangeDebounced(value);
  };

  return (
    <TextInput
      label={ts(question.name)} hideLabels
      name={'question-' + question.questionId}
      text={value}
      audios={getAttachmentsOfType(answer.attachments, AUDIO_CATEGORY)}
      onChange={(e) => onInput(e.target.value)}
      onChangeAudio={(audio) => {
        onChangeDebounced.cancel();
        onChange({ ...answer, value, attachments: updateAttachmentsOfType(answer.attachments, AUDIO_CATEGORY, audio) });
      }}
      showCharacterCount={!!question.maxLength}
      maxLength={question.maxLength}
      textarea
    />
  );
  
};
